import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_5: FaireProductEntity = {
  token: "caden-lane-5",
  type: "product",
  name: "Sweet Like Candy Two Piece Pajama Set | Blue",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/fd14f0c68a8f2ec85a59a2215196bb09ee676423fa39a286c250e40ea656f516.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1798,1798,x0,y0,safe&width=720",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
